import PropTypes from 'prop-types';
import React from 'react';

import * as DetailPages from '$pages/detail/index';
import Meta from '$partials/global/meta';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

export const DetailPageDispatcher = (props) => {
    if (!props?.page?.__typename || typeof (DetailPages[props?.page?.__typename]) === 'undefined') {
        return null;
    }

    const Component = DetailPages[props?.page?.__typename];
    return (
        <>
            <Meta
                description={props.page?.searchDescription || props.page?.listingText}
                image={props.page?.listingImage}
                page={props.page}/>
            <Component {...props} />
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

DetailPageDispatcher.propTypes = {
    page: PropTypes.shape({
        __typename: PropTypes.string.isRequired,
        listingText: PropTypes.string,
        listingImage: PropTypes.object,
        searchDescription: PropTypes.string,
    }).isRequired,
};

